module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/close2-30fa0ee8ee018b5f0ffe7dc771f0ab3c.svg";